<!--
 * @Description: 语音组件
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-04 17:32:15
 duration
 -->

<template>
  <v-list>
    <v-card class="mx-auto" max-width="344" outlined>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title style="min-width: 100px;" >{{ time }} s</v-list-item-title>
          <v-list-item-subtitle>  {{ getCurrentPosition }} </v-list-item-subtitle>
        </v-list-item-content>
        <v-spacer></v-spacer>
        <v-list-item-icon>
          <v-btn icon>
            <v-icon>mdi-rewind</v-icon>
          </v-btn>
        </v-list-item-icon>
        <v-list-item-icon :class="{ 'mx-5': $vuetify.breakpoint.mdAndUp }">
          <v-btn icon @click="play(message)" v-if="this.amr == null || this.amr.isPlaying()">
            <v-icon>mdi-pause</v-icon>
          </v-btn>
          <v-btn icon @click="play(message)" v-else>
            <v-icon>play_arrow</v-icon>
          </v-btn>
        </v-list-item-icon>
        <v-list-item-icon class="ml-0" :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
          <v-btn icon >
            <v-icon>mdi-fast-forward</v-icon>
          </v-btn>
        </v-list-item-icon>
      </v-list-item>
    </v-card>
  </v-list>
</template>

<script>
import BenzAMRRecorder from "benz-amr-recorder";
export default {
  props: ["message","time"],
  data() {
    return {
      dialog: false,
      amr: null,
      getDuration: 0,
      getCurrentPosition: 0
    };
  },
  mounted() { this.amr = new BenzAMRRecorder(); },
  methods: {
    info(state) {
      this.dialog = state;
    },
    play(url) {
      this.amr = new BenzAMRRecorder();
      this.amr.initWithUrl(url).then(()=>{
        // amr.isPlaying() 返回音频的播放状态 是否正在播放 返回boolean类型
        if (this.amr.isPlaying()) {
          this.amr.stop();
        } else {
          this.amr.play();
          this.getDuration = this.amr.getDuration();
        }
      });
    }
  }
};
</script>